import {
   ConfidentialAccessLevel,
   ConfidentialityConfiguration,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

export const getAccessDurationHours = (
   configuration: ConfidentialityConfiguration,
   accessLevel: ConfidentialAccessLevel
): number => {
   const duration =
      accessLevel === 'MONITORED' ? configuration.monitoredAccessDuration : configuration.authorizedAccessDuration;

   return duration.toHours();
};
